"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeniencyReason = void 0;
var LeniencyReason;
(function (LeniencyReason) {
    LeniencyReason["DunningFees"] = "dunning_fees";
    LeniencyReason["Complaint"] = "complaint";
    LeniencyReason["CancellationCompensation"] = "cancellation_compensation";
    LeniencyReason["Commercial"] = "commercial";
    LeniencyReason["Correction"] = "correction";
})(LeniencyReason = exports.LeniencyReason || (exports.LeniencyReason = {}));
